/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type WalletVendorEnum = (typeof WalletVendorEnum)[keyof typeof WalletVendorEnum];

export const WalletVendorEnum = {
  google_pay: 'google_pay',
  apple_pay: 'apple_pay',
  link: 'link',
} as const;
